































import { Component, Vue } from 'vue-property-decorator';
import { analysisStores } from '@/store/poultry/analysis';
import dayjs from 'dayjs';

@Component({
  components: {}
})
export default class VisualAnalysisChartHeader extends Vue {
  store = analysisStores.visual.list;

  date: string | null = null;
	notExporting = true;

  get visual() {
    return this.store.visual;
  }

  get categoryType() {
    return this.store.categoryType;
  }

  get startDate() {
    let date: any = this.store.startDate;
    return dayjs(date).format('MMM YYYY');
  }

  get endDate() {
    let date: any = this.store.endDate;
    return dayjs(date).format('MMM YYYY');
  }

  get clientName() {
    return this.store.clientName;
  }

  get analysisType() {
    return this.store.analysisType;
  }

  get systemType() {
    if (this.store.systemTypeText == 'All')
      return 'whole system';
    return this.store.systemTypeText;
  }

  get chartStyle() {
    return this.store.chartStyle;
  }

  handleExportButtonClicked() {
		this.notExporting = false;
		setTimeout(() => {
			window.print();
			this.notExporting = true;
		}, 50);
  }

  updateChartStyle(style: string) {
    this.store.setChartStyle(style)
  }
}
